export const WHITELIST = ['/login', '/404']
